// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1s3HN","content":"styles_content__ZsVAm"};